import React from "react";
import Badge1IMG from "../pics/circle check.svg";
import Badge2IMG from "../pics/intel.svg";
import Badge3IMG from "../pics/plusnotenote+.svg";
import Badge4IMG from "../pics/house.svg";
import { motion } from 'framer-motion';
import BadgeComponent from "./BadgeComponents";

const badgesData = [
  { imageSrc: Badge1IMG, title: "Guaranteed", description: "Qualified Assessments" },
  { imageSrc: Badge2IMG, title: "Services", description: "Fitted To Your Needs" },
  { imageSrc: Badge3IMG, title: "Availability", description: "Flexible Appointments" },
  { imageSrc: Badge4IMG, title: "Local To", description: "Greater Manchester" },
];

export const Badges = () => {
  return (
    <motion.div 
      initial={{ y: 120, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className=" ">
        <ul className="grid grid-cols-2 md:grid-cols-4 gap-8 mx-auto max-w-6xl">
          {badgesData.map((badge, index) => (
            <li key={index} className="flex justify-center">
              <BadgeComponent
                imageSrc={badge.imageSrc}
                title={badge.title}
                description={badge.description}
              />
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};
export default Badges;